import { audio } from '../systems/audio/AudioSystem.js';

/** Settings hub: volume/effects settings, controls reference, redeem code, version history, and account (Profile). */
export class SettingsHubMenu {
  constructor(root, save, { onSettings, onControls, onRedeemCode, onVersionHistory, onLogin, onStatistics, onLore, onBack }) {
    this.root = root;
    this.el = document.createElement('div');
    this.el.className = 'menu-overlay';
    this.el.innerHTML = `
      <div class="menu-title">SETTINGS</div>
      <div class="menu-buttons menu-buttons-vertical">
        <button type="button" class="menu-button" data-action="settings">Settings</button>
        <button type="button" class="menu-button" data-action="controls">Controls</button>
        <button type="button" class="menu-button" data-action="redeem">Redeem Code</button>
        <button type="button" class="menu-button" data-action="version-history">Updates</button>
        <button type="button" class="menu-button" data-action="statistics">Statistics</button>
        <button type="button" class="menu-button" data-action="lore">The Archive</button>
        <button type="button" class="menu-button" data-action="login">${save.accountUsername ? `@${save.accountUsername}` : (save.profileName ? `Profile: ${save.profileName}` : 'Profile')}</button>
      </div>
    `;
    this.el.querySelector('[data-action="settings"]').addEventListener('click', () => { audio.playSfx('click'); onSettings(); });
    this.el.querySelector('[data-action="controls"]').addEventListener('click', () => { audio.playSfx('click'); onControls(); });
    this.el.querySelector('[data-action="redeem"]').addEventListener('click', () => { audio.playSfx('click'); onRedeemCode(); });
    this.el.querySelector('[data-action="version-history"]').addEventListener('click', () => { audio.playSfx('click'); onVersionHistory(); });
    this.el.querySelector('[data-action="statistics"]').addEventListener('click', () => { audio.playSfx('click'); onStatistics(); });
    this.el.querySelector('[data-action="lore"]').addEventListener('click', () => { audio.playSfx('click'); onLore(); });
    this.el.querySelector('[data-action="login"]').addEventListener('click', () => { audio.playSfx('click'); onLogin(); });

    const back = document.createElement('button');
    back.type = 'button';
    back.className = 'menu-button';
    back.textContent = 'Back';
    back.addEventListener('click', () => { audio.playSfx('click'); onBack(); });
    this.el.appendChild(back);

    this.root.appendChild(this.el);
  }

  destroy() {
    this.el.remove();
  }
}
